module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "top"
    }
  }, [_c('section', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "banner__caption"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('Home.bloc1.title')))]), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('Home.bloc1.content1')) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('Home.bloc1.content2')) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('Home.bloc1.content3')) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('Home.bloc1.content5')) + "\n                    ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://itunes.apple.com/us/app/chaperon/id1366598828?ls=1&mt=8",
      "target": "_blank",
      "alt": "Chaperon apple store",
      "title": _vm.$t('Home.bloc1.downloadiOs')
    }
  }, [_c('img', {
    staticClass: "button",
    attrs: {
      "src": "static/img/app-store.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.pandaaz.chaperon",
      "target": "_blank",
      "alt": "Chaperon play store",
      "title": _vm.$t('Home.bloc1.downloadAndroid')
    }
  }, [_c('img', {
    staticClass: "button",
    attrs: {
      "src": "static/img/g-play.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('Home.bloc1.content4')) + "\n                    ")])]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('section', {
    staticClass: "section-intro",
    attrs: {
      "id": "intro"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('div', {
    staticClass: "section-intro__text"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('Home.bloc2.title')))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.$t('Home.bloc2.name')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Home.bloc2.def')))])]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('Home.bloc2.content1')) + "\n                            ")])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section-desc text-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 section-desc__caption"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('Home.bloc3.title')))]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.$t('Home.bloc3.content1')) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "section-desc__block"
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('Home.bloc3.chaperon-header')) + "\n                            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
    staticClass: "sprite-couple"
  }, [_vm._v(" ")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Home.bloc3.chaperon-block1-title')))]), _vm._v(" "), _c('p', [_vm._v("\n                                       " + _vm._s(_vm.$t('Home.bloc3.chaperon-block1-content')) + "\n                                    ")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "sprite-point"
  }, [_vm._v(" ")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Home.bloc3.chaperon-block2-title')))]), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(_vm.$t('Home.bloc3.chaperon-block2-content')) + "\n                                    ")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "sprite-excng"
  }, [_vm._v(" ")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Home.bloc3.chaperon-block3-title')))]), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(_vm.$t('Home.bloc3.chaperon-block3-content')) + "\n                                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "section-desc__block section-desc__block--modifier"
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('Home.bloc3.chappy-header')) + "\n                            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    staticClass: "img-prediction",
    attrs: {
      "src": "static/img/img-prediction.png"
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Home.bloc3.chappy-block1-title')))]), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(_vm.$t('Home.bloc3.chappy-block1-content')) + "\n                                    ")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "sprite-bot"
  }, [_vm._v(" ")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('Home.bloc3.chappy-block2-title')))]), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(_vm.$t('Home.bloc3.chappy-block2-content')) + "\n                                    ")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "sprite-evaluat"
  }, [_vm._v(" ")]), _vm._v(" "), _c('h4', [_vm._v(" " + _vm._s(_vm.$t('Home.bloc3.chappy-block3-title')) + " ")]), _vm._v(" "), _c('p', [_vm._v("\n                                        " + _vm._s(_vm.$t('Home.bloc3.chappy-block3-content')) + "\n                                    ")])])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section-genesis"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center section-genesis__caption"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('Home.bloc4.title')))]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.$t('Home.bloc4.content1')) + "\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "genesis__steps"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "genesis__block clearfix"
  }, [_c('div', {
    staticClass: "genesis__text"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Home.bloc4.genese-block1-title')))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('Home.bloc4.genese-block1-content1'))), _c('br'), _vm._v("\t\t\t\t\t\t\t\t\t\t\n                                " + _vm._s(_vm.$t('Home.bloc4.genese-block1-content2')) + "\n                            ")])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "genesis__block clearfix"
  }, [_c('div', {
    staticClass: "genesis__text genesis__text--modifier"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Home.bloc4.genese-block2-title')))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('Home.bloc4.genese-block2-content1'))), _c('br'), _vm._v("\t\t\t\t\t\t\t\t\t\t\n                                " + _vm._s(_vm.$t('Home.bloc4.genese-block2-content2')) + " \n                            ")])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "genesis__block clearfix"
  }, [_c('div', {
    staticClass: "genesis__text"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Home.bloc4.genese-block3-title')))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('Home.bloc4.genese-block3-content')) + "\n                            ")])]), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "genesis__block clearfix"
  }, [_c('div', {
    staticClass: "genesis__text genesis__text--modifier"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('Home.bloc4.genese-block4-title')))]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(_vm.$t('Home.bloc4.genese-block4-content')) + "\n                            ")])]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "chaperon-bird"
  }, [_c('img', {
    attrs: {
      "src": "static/img/art5.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Home.bloc4.motto')))])])])])]), _vm._v(" "), _c('section', {
    staticClass: "slider text-center",
    attrs: {
      "id": "influenceur"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('Home.bloc6.title')))]), _vm._v(" "), _c('div', {
    staticClass: "slider__item font-white"
  }, [_c('carousel', {
    attrs: {
      "autoplay": true,
      "autoplayHoverPause": true,
      "loop": true,
      "perPageCustom": [
        [1199, 3],
        [320, 2]
      ],
      "centerMode": true
    }
  }, [_c('slide', [_c('div', {
    staticClass: "slider__item__block text-center"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/s/aGlnaGxpZ2h0OjE4MDcyNDU2NTQxMDc5NTE5?igshid=12onm13w9l7ew",
      "target": "_blank"
    }
  }, [_vm._v("@ALICECATDESIGN")])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "slider__item__block text-center"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/s/aGlnaGxpZ2h0OjE3ODYyMTIzNTQ0NDQ4NTc5?igshid=18jedjpsm4cq5",
      "target": "_blank"
    }
  }, [_vm._v("@DEPONTEARNAUD")])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "slider__item__block text-center"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/s/aGlnaGxpZ2h0OjE3ODcyNjgwODgzMzk4NTg5?igshid=htcmof3n7v8s",
      "target": "_blank"
    }
  }, [_vm._v("@DAILYLIVESOF.S")])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "slider__item__block text-center"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/s/aGlnaGxpZ2h0OjE4MDUyNzc1NTQyMDg3Mjc0?igshid=y1f433kbq9yi",
      "target": "_blank"
    }
  }, [_vm._v("@GREGRAW1")])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "slider__item__block text-center"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/s/aGlnaGxpZ2h0OjE4MDQ3MDkxNjQzMTgwOTY5?igshid=sxaeo0skf99s",
      "target": "_blank"
    }
  }, [_vm._v("@ONLYBRIGHTNESS")])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "slider__item__block text-center"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/stories/highlights/18087351241006832/",
      "target": "_blank"
    }
  }, [_vm._v("@LILYS_FAIRY_TOUCH")])])])]), _vm._v(" "), _c('slide', [_c('div', {
    staticClass: "slider__item__block text-center"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/stories/highlights/18077528218107197/",
      "target": "_blank"
    }
  }, [_vm._v("@LOXILAUX")])])])])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "font-white"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('Home.bloc6.content1')) + "\n                ")])])]), _vm._v(" "), _c('section', {
    staticClass: "section-partners text-center",
    attrs: {
      "id": "quizz"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 section-genesis__caption"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('Home.bloc5.title')))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.$t('Home.bloc5.content1')) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 "
  }, [_c('button', {
    staticClass: "btn-purple btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goToQuizz(2)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-female"
  }), _vm._v(" " + _vm._s(_vm.$t('Home.bloc5.quizz-woman')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 "
  }, [_c('button', {
    staticClass: "btn-purple btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goToQuizz(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-male"
  }), _vm._v(" " + _vm._s(_vm.$t('Home.bloc5.quizz-man')))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner__phone"
  }, [_c('img', {
    attrs: {
      "src": "static/img/iphone.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "section-intro__img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/ui_screens.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "section-desc__title"
  }, [_c('i', {
    staticClass: "sprite-chaperon"
  }, [_vm._v(" ")]), _vm._v(" Chaperon")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "section-desc__title section-desc__title--modifier"
  }, [_c('i', {
    staticClass: "sprite-bachelor"
  }, [_vm._v(" ")]), _vm._v(" Chappy")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "genesis__img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/art1.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "genesis__img genesis__img--modifier"
  }, [_c('img', {
    attrs: {
      "src": "static/img/art2.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "genesis__img"
  }, [_c('img', {
    attrs: {
      "src": "static/img/art3.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "genesis__img genesis__img--modifier"
  }, [_c('img', {
    attrs: {
      "src": "static/img/art4.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("\n                             \n                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                             \n                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                             \n                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                             \n                        ")]), _vm._v(" "), _c('li', [_vm._v("\n                            T\n                        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b707dd8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 69
// module chunks = 0